define(
    ["jquery", "domReady", "wcs.find-in-store-model", "wcs.utils", "wcs.context"],
    function($, domReady, findInStoreModel, utils, ctx) {
        var DEBUG = false;
        var inStoreAvailabilityAutoSuggest = {
            action: 'after',
            searchContainer: '.zip-input-wrapper',
            template: 'html.in-store-availability-autocomplete.base',
            resultsContainer: '.in-store-availability-autocomplete-results',
            numsuggestions : 7,
            loadParameters: {
                target: '.in-store-availability-search-autocomplete-form-js',
                pluginFN: 'inStoreAvailabilityAutoComplete',
                requireModule: 'in-store-availability-autocomplete'
            },
            ajaxParams: {
                url: 'VFAjaxGetCityStateAPI',
                data: {}
            }
        },
        $findInStoreModal,
        $findInStoreContainer,
        $findStoreForm,
        $sizeValueWrapper,
        $storeFinderTitle,
        $sizeSelectToggleButton,
        $selectSizeWrapper,
        $zipCodeErrorMessage,
        isSplitSizesEnabled = false,
        splitSizedEnabledClass = 'split-sizes-enabled';

        domReady(function () {
            $findInStoreModal = $('#find-in-store-modal');
            $findInStoreContainer = $(".find-store-container-js");
            $findStoreForm = $findInStoreContainer.find('.find-a-store-form-js');
            $sizeValueWrapper = $findInStoreContainer.find('.size-value-wrapper-js');
            $storeFinderTitle = $findInStoreContainer.find('.store-finder-title-js');
            $sizeSelectToggleButton = $findInStoreContainer.find('.size-value-js');
            $selectSizeWrapper = $findInStoreContainer.find('.select-size-wrapper-js');
            $zipCodeErrorMessage = $findInStoreContainer.find('.zipcode-error-msg');
            isSplitSizesEnabled = getIsSplitSizedEnabled();

            if(isSplitSizesEnabled) {
                $findInStoreModal.addClass(splitSizedEnabledClass);
            }
        });

        //call api loader and pass a module definition
        main.handleBarsModulesInit(inStoreAvailabilityAutoSuggest);

        function clearRetailStoreForm() {
            $('.store-results-count-js').empty();
            $('.found-stores-js').empty();
            $('.find-in-store-accordion.accordion_js').empty();
            $('.store-details-js').hide();
        }

        function hideRetailStoreInfo() {
            $('.store-results-count-js').empty();
            $('.found-stores-js').empty();
            $('.store-details-js').hide();
            $('.find-store-container-js').addClass('hide');
        }

        function setEnteredZipToCookie(zip) {
            if (DEBUG) console.log('set USER_ENTERED_ZIP zip value', zip);
            ctx.setCookie('USER_ENTERED_ZIP', zip);
        }

        function getZipCookie(zipCookie) {
            var result = ctx.getCookie(zipCookie);
            if (result !== null && result !== undefined) {
                return result;
            }
            return undefined;
        }

        function getFavCookie() {
            var cookieName = WCS_CONFIG.get("BOPIS::bopisFavStore") + ctx.getStoreId();
            var result = ctx.getCookie(cookieName);
            if (result !== null && result !== undefined) {
                return result;
            }
            return undefined;
        }

        function openPopup() {
            if ($findInStoreModal.length) {
                $findInStoreModal.foundation('open');
            }

            $('.store-results-list').empty();
        }

    	function openFindInStoreContainer($container) {
    		$container.slideToggle();
    		 $('html, body, .reveal-overlay:visible').animate({
    			   scrollTop: $container.offset().top
    			}, 500);
    		 $('.lazyload', $container).lazyload();
        }

        function closeFindInStoreContainer($container){
    		$container.slideToggle();
    		$('html, body, .reveal-overlay:visible').animate({
    			  scrollTop: $('.product-form-js').offset().top
    		  }, 500);
        }

        function readProductSizes() {
            var $sizeContainer = $('.attr-size.selection-js');

            if ($sizeContainer.length === 0) {
                $sizeContainer = $('#attr-size').parents('[data-attribute-id]');
            }

            var sizeAttributeId = $sizeContainer.data('attributeId');
            var availabilityData = findInStoreModel.getProductAvailabilityJSON();
            var sizeData = availabilityData.attributes[sizeAttributeId];

            var selectedColorData = null;
            var colorAttributeId = $('.attr-color-js').data('attributeId');
            var colorData = availabilityData.attributes[colorAttributeId];

            if (colorData) {
                var colorName = $findInStoreContainer
                    .find('.color-value-js')
                    .text()
                    .trim()
                    .toLowerCase();

                for (var i = 0; i < colorData.length; i++) {
                    if (colorData[i].display.trim().toLowerCase() === colorName) {
                        selectedColorData = colorData[i];
                        break;
                    }
                }
            }

            return sizeData.map(function (sizeItem) {
                var text = sizeItem.display.split(' ');
                var displayValue = text[0];

                if (typeof text[1] === 'string') {
                    displayValue += ' ' + text[1].charAt(0);
                }

                var catentryId = null;

                if (selectedColorData) {
                    for (var i = 0; i < selectedColorData.catentryId.length; i++) {
                        for (var j = 0; j < sizeItem.catentryId.length; j++) {
                            if (selectedColorData.catentryId[i] === sizeItem.catentryId[j]) {
                                catentryId = sizeItem.catentryId[j];
                                break;
                            }
                        }
                        if (catentryId) {
                            break;
                        }
                    }
                }

                return {
                    value: sizeItem.display,
                    displayValue: displayValue,
                    catentryId: catentryId || sizeItem.catentryId[0],
                };
            });
        }

        function updateActiveProductData() {
            var $selectedColor = $('.color-swatches-js .attr-box.selected');
            var $selectedColorImg = $selectedColor.find('img');

            if ($selectedColorImg.length === 1) {
                var btnData = $selectedColor.data();
                var imgData = $selectedColorImg.data();
                var productData = {
                    productName: imgData.productName,
                    colorName: btnData.attributeValue,
                    imageUrl: imgData.descriptionImage || $selectedColorImg.attr('src'),
                };

                $findInStoreContainer.find('.find-retail-store-product-name').html(productData.productName);
                $findInStoreContainer.find('.find-retail-store-product-image > img').attr('src', productData.imageUrl);
                $findInStoreContainer.find('.color-value-js').html(productData.colorName);
            }
        }

        function updateProductSizes() {
            if (isSplitSizesEnabled) {
                renderSplitSizesContainer();
            } else {
                var sizes = readProductSizes();

                $findInStoreContainer.find('.select-size-container-js').html(
                    sizes
                        .map(function (size) {
                            return '<button class="select-size-button select-size-button-js" data-attribute-value="'+ size.value +'" data-catentry-id="'+ size.catentryId +'">'+ size.displayValue +'</button>';
                        })
                        .join('\n')
                );
            }
        }

        function renderSplitSizesContainer() {
            var $sizesContainer = $('.attr-size.selection-js'),
                $modalSelectSizeContainer = $findInStoreContainer.find('.select-size-container-js'),
                $size,
                $width,
                $sizeTitle,
                $widthTitle;

            $modalSelectSizeContainer
                .empty()
                .append("<div class='step-container step-container-width'></div>")
                .append("<div class='step-container step-container-size'></div>");

            // Clone size selection
            if ($($sizesContainer[0]).find('.step-content-width').length > 0) {
                $width = $($sizesContainer[0]).find('.product-content-form-step-content').clone();
                $widthTitle = $($sizesContainer[0]).find('.product-content-form-step-label').clone();
                $size = $($sizesContainer[1]).find('.product-content-form-step-content').clone();
                $sizeTitle = $($sizesContainer[1]).find('.product-content-form-step-label').clone();
            } else {
                $width = $($sizesContainer[1]).find('.product-content-form-step-content').clone();
                $widthTitle = $($sizesContainer[1]).find('.product-content-form-step-label').clone();
                $size = $($sizesContainer[0]).find('.product-content-form-step-content').clone();
                $sizeTitle = $($sizesContainer[0]).find('.product-content-form-step-label').clone();
            }
            // Add sizes into size selection container
            $modalSelectSizeContainer.find(".step-container-width").append([$widthTitle, $width]);
            $modalSelectSizeContainer.find(".step-container-size").append([$sizeTitle, $size]);
            $modalSelectSizeContainer.find('button.attr-box').addClass('select-size-button select-size-button-js');
        }

        function getIsSplitSizedEnabled () {
            return $('.step-content-width').length > 0 && $('.attr-size.selection-js').length > 1;
        }

        function getSelectedSize() {
            var size = null;
            var $findInStoreSizeElement = $findInStoreContainer.find('.select-size-button.selected');
            var $pdpSizeSwatch = $('.attr-size .attr-box.selected');
            var $pdpSizeOption = $('#attr-size option:selected:not(.attr-size-deselected-js)');

            if ($findInStoreSizeElement.length === 1) {
                size = $findInStoreSizeElement.data('attribute-value');
            } else if ($pdpSizeSwatch.length === 1) {
                size = $pdpSizeSwatch.data('attribute-value');
            } else if ($pdpSizeOption.length === 1) {
                size = $pdpSizeOption.data('attribute-value');
            }

            return size;
        }

        function getSelectedSplitSize() {
            var size = null,
                width = null,
                $sizeElement = $findInStoreContainer.find('.step-container-size').find('.select-size-button.selected'),
                $widthElement = $findInStoreContainer.find('.step-container-width').find('.select-size-button.selected');

            size = $sizeElement.length === 1 ? $sizeElement.data('attribute-value') : null;
            width = $widthElement.length === 1 ? $widthElement.data('attribute-value') : null;

            return ({
                'size': size,
                'width': width
            });
        }

        function handleSplitSizeSelected($target) {
            var $targetParent = $target.parents('.product-content-form-step-content'),
                selections = getSelectedSplitSize();
            $targetParent.find('.select-size-button-js').removeClass('selected');
            $target.addClass('selected');

            //When both size is selected
            if (selections.size && selections.width) {
                var catEntryId = getSplitSizeCatEntryId(selections.size, selections.width);
                updateActiveSize(selections.size, catEntryId, selections.width);
                setSizeSelectedView();
            }
        }

        function getSplitSizeCatEntryId(size, width) {
            var availabilityData = findInStoreModel.getProductAvailabilityJSON();
            var attributes = availabilityData.attributes,
                catEntryId = null;
            if (attributes) {
                var target = size + " " + width;
                var found = false;
                $.each(attributes, function(key, attr) {
                    
                    $.each(attr, function(key, data) {
                        if (data.display == target) {
                            catEntryId = data.catentryId[0];
                            found = true;
                            return;
                        }
                    });

                    if (found) return;
                });
            }
            return catEntryId;
        }

        function setSizeSelectedView() {
            setSelectSizeView(false);
            $findInStoreModal.removeClass('size-not-selected');
            $findStoreForm.removeClass('hide');
            $sizeValueWrapper.removeClass('hide');
            $storeFinderTitle.removeClass('hide');
        }

        function setSizeNotSelectedView() {
            setSelectSizeView(true);
            $findInStoreModal.addClass('size-not-selected');
            $findStoreForm.addClass('hide');
            $sizeValueWrapper.addClass('hide');
            $storeFinderTitle.addClass('hide');
        }

        function updateActiveSize(size, catentryId, width) {
            var $sizeSelectButtons = $findInStoreContainer.find('.select-size-button-js');

            $sizeSelectButtons
                .removeClass('selected');

            $sizeSelectButtons
                .filter('[data-attribute-value="'+ size +'"]')
                .addClass('selected');
            
            if (isSplitSizesEnabled) {
                $sizeSelectButtons
                .filter('[data-attribute-value="'+ width +'"]')
                .addClass('selected');
            }

            var sizeText = size;
            if (width) {
                sizeText = sizeText + " " + width;
            }
            if (LANG_FIND_IN_STORE.ROBIS_SIZE_SWITCH_BUTTON_TEXT) {
                sizeText += ' <a href="javascript:">(' + LANG_FIND_IN_STORE.ROBIS_SIZE_SWITCH_BUTTON_TEXT + ')</a>';
            }

            $sizeValueWrapper
                .find('.size-value-js')
                .html(sizeText);

            if (catentryId) {
                $findInStoreContainer.find('.find-retail-store-catentryid-js').val(catentryId);
            }
        }

        function setSelectSizeView(isOpen) {
            if (isOpen) {
                $sizeSelectToggleButton.addClass('open');
                $selectSizeWrapper.removeClass('hide');
            } else {
                $sizeSelectToggleButton.removeClass('open');
                $selectSizeWrapper.addClass('hide');
            }
        }

        function setRobisFinishedView(response) {
            $findInStoreContainer.addClass('hide');

            if (response && response.reservationId) {
                $findInStoreModal.find('.robis-reservation-id-js').html(' ' + response.reservationId + '.');
            }

            $findInStoreModal
                .find('.robis-finished-message')
                .removeClass('hide');
        }

        function getROBISReserveForm() {
            return $('.robis-reserve-form-wrapper-js')
                .clone()
                .removeClass('hide');
        }

        function createROBISErrorMessage(message) {
            return '<div class="row collapse robis-error-message-wrapper-js"><div class="columns small-12"><p class="robis-reserve-form-error-message">'+ message +'</p></div></div>';
        }

        function clearROBISErrorMessage() {
            $findInStoreContainer
                .find('.robis-error-message-wrapper-js')
                .remove();
        }

        function scrollToROBISForm() {
            var $activeForm = $('.store-results-list-js .robis-reserve-form-wrapper-js');
            $('.reveal-overlay:visible').animate({scrollTop: $activeForm.position().top});
        }

        function resetROBIS() {
            var $finishedMessage = $findInStoreModal.find('.robis-finished-message');
            if (!$finishedMessage.hasClass('hide')) {
                $finishedMessage.addClass('hide');
            }

            if (!$zipCodeErrorMessage.hasClass('hide')) {
                $zipCodeErrorMessage.addClass('hide');
            }

            $findInStoreContainer
                .find('.select-size-button-js.selected')
                .removeClass('selected');

            updateActiveProductData();
            updateProductSizes();
        }

        return {
            openPopup: openPopup,
            openFindInStoreContainer: openFindInStoreContainer,
            closeFindInStoreContainer: closeFindInStoreContainer,
            setEnteredZipToCookie: setEnteredZipToCookie,
            getZipCookie: getZipCookie,
            getFavCookie: getFavCookie,
            clearRetailStoreForm: clearRetailStoreForm,
            hideRetailStoreInfo: hideRetailStoreInfo,
            updateActiveProductData: updateActiveProductData,
            getSelectedSize: getSelectedSize,
            setSizeSelectedView: setSizeSelectedView,
            setSizeNotSelectedView: setSizeNotSelectedView,
            updateActiveSize: updateActiveSize,
            setSelectSizeView: setSelectSizeView,
            setRobisFinishedView: setRobisFinishedView,
            getROBISReserveForm: getROBISReserveForm,
            createROBISErrorMessage: createROBISErrorMessage,
            clearROBISErrorMessage: clearROBISErrorMessage,
            scrollToROBISForm: scrollToROBISForm,
            resetROBIS: resetROBIS,
            getIsSplitSizedEnabled: getIsSplitSizedEnabled,
            getSelectedSplitSize: getSelectedSplitSize,
            handleSplitSizeSelected: handleSplitSizeSelected,
            getSplitSizeCatEntryId: getSplitSizeCatEntryId
        };

    });
